import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { ISessionPersistenceService } from './session-persistence.interface';
import { IStateObject } from '../../interfaces';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class SessionPersistenceMock implements ISessionPersistenceService {
    save(): void {
        AlkLogger.info('[SessionPersistenceMock#save]');
    }
    forceSave(): void {
        AlkLogger.info('[SessionPersistenceMock#forceSave]');
    }
    stateObservable = (): Observable<IStateObject> => NEVER;
}
